import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'

import NotFound from 'errorPages/NotFound'

import DesignBenefit from './design'
import { DESIGN_BENEFIT_PATH } from './design'
import DesignBenefitSummary from './summary'

export const BENEFIT_DETAILS_PATH = 'benefit-details'

const BenefitDetails: React.FC = () => {
  let match = useRouteMatch()

  return (
    <Switch>
      <Route path={`${match.path}`} exact component={DesignBenefitSummary} />
      <Route path={`${match.path}/${DESIGN_BENEFIT_PATH}/:planPeriod`} exact component={DesignBenefit} />
      <Route path={`${match.path}/${DESIGN_BENEFIT_PATH}/:planPeriod/:step`} exact component={DesignBenefit} />
      <Route component={NotFound} />
    </Switch>
  )
}

export default BenefitDetails
